import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { display, getOptionLabel, currency, numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import tableStyles from '../styles/GeneralTableInfo.scss';

const ProbationSettingShow = props => {
  const { employeeProbationSetting, probationTaxOptions, probationSalaryTypes } = props;
  const { t } = useTranslation();
  const probationSalaryType = employeeProbationSetting?.salaryType;

  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.ProbationSetting.probation_end')}：</th>
            <td>{display(formatDate(employeeProbationSetting?.probationEnd))}</td>
          </tr>

          <tr>
            <th>{t('features.Employees.components.ProbationSetting.probation_tax_setting')}：</th>
            <td>{display(getOptionLabel(employeeProbationSetting?.taxSetting)(probationTaxOptions))}</td>
          </tr>

          <tr>
            <th>{t('features.Employees.components.ProbationSetting.probation_salary_type')}：</th>
            <td>{display(getOptionLabel(employeeProbationSetting?.salaryType)(probationSalaryTypes))}</td>
          </tr>

          {probationSalaryType === 'amount' && (
            <tr>
              <th>{t('features.Employees.components.ProbationSetting.probation_base_salary')}：</th>
              <td>{currency(numberWithComma(decimalPlace2(employeeProbationSetting.baseSalary)))}</td>
            </tr>
          )}

          {probationSalaryType === 'percentage' && (
            <tr>
              <th>{t('features.Employees.components.ProbationSetting.probation_salary_rate')}：</th>
              <td>{numberWithComma(decimalPlace2(employeeProbationSetting.salaryRate))}%</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeProbationSetting: selector(getItem(REDUCER_NAME, state), 'employeeProbationSetting'),
  probationTaxOptions: getRadioOptions(state, 'probationTaxOptions'),
  probationSalaryTypes: getRadioOptions(state, 'probationSalaryTypes')
});

export default connect(mapStateToProps)(ProbationSettingShow);
